import { showHttpError } from '@calendly/alert'
import { httpRequest } from '@calendly/http-tools'

export const LOADING_STATE = 'loading'
export const IDLE_STATE = 'idle'
const EDITING_STATE = 'editing'

export const startMarkingInviteeAsNoShow = (id) => ({
  type: 'UPDATE_INVITEE',
  payload: {
    id,
    settingNoShowStatusState: EDITING_STATE
  }
})

export const stopMarkingInviteeAsNoShow = (id) => ({
  type: 'UPDATE_INVITEE',
  payload: {
    id,
    settingNoShowStatusState: IDLE_STATE
  }
})

const updateNoShowStatus = (id, eventId, httpMethod) => async (dispatch) => {
  dispatch({
    type: 'UPDATE_INVITEE',
    payload: {
      id,
      settingNoShowStatusState: LOADING_STATE
    }
  })

  const [success, responseData] = await httpRequest({
    method: httpMethod,
    url: '/api/dashboard/invitee_dispositions/no_shows',
    data: {
      invitee_id: id
    }
  })

  if (success) {
    dispatch({
      type: 'UPDATE_INVITEE',
      payload: {
        ...responseData,
        settingNoShowStatusState: IDLE_STATE
      }
    })
    dispatch({
      type: 'UPDATE_NO_SHOW_INVITEES_COUNT',
      payload: {
        eventId
      }
    })
  } else {
    dispatch(showHttpError(responseData))
    dispatch({
      type: 'UPDATE_INVITEE',
      payload: {
        id,
        settingNoShowStatusState: IDLE_STATE
      }
    })
  }
}

export const undoNoShowForInvitee = (id, eventId) => async (dispatch) => {
  dispatch(updateNoShowStatus(id, eventId, 'DELETE'))
}

export const markInviteeAsNoShow = (id, eventId) => async (dispatch) => {
  dispatch(updateNoShowStatus(id, eventId, 'POST'))
}
